webpackJsonp([11243674037275],{

/***/ 1556:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"SelectedItemsInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":"false","description":null,"name":"selectedAll","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":"[]","description":null,"name":"selectedCategories","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}},{"defaultValue":"[]","description":null,"name":"selectedIds","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-selected-items-input-c83e87f97c82f09ceebd.js